import styled, { StyledProps } from 'styled-components/macro';

export type TimePickerStylesProps = StyledProps<{
  isOpen?: boolean;
  isActive?: boolean;
  hasError?: boolean;
}>;

export const TimePicker = styled.div<TimePickerStylesProps>`
  position: relative;
  display: inline-block;
`;

export const Button = styled.div<TimePickerStylesProps>`
  height: 30px;
  width: 100px;
  border-radius: 3px;
  background-color: #fff;
  border: ${(props) =>
    props.hasError ? '0.5px solid #FD0F0F' : '0.5px solid #c3cfd9'};
  box-sizing: border-box;
  border-radius: 3px;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 0 0 5px;
  box-shadow: ${(props) =>
    props.hasError
      ? '2px 2px 0px #FFD6D7, -2px 2px 0px #FFD6D7, 2px -2px 0px #FFD6D7, -2px -2px 0px #FFD6D7, inset 0px 2px 2px rgba(0, 0, 0, 0.08)'
      : 'none'};

  & > svg {
    margin-right: 7px;
  }
`;

export const Menu = styled.div<TimePickerStylesProps>`
  position: absolute;
  top: calc(100% + 5px);
  height: 176px;
  width: 149px;
  border-radius: 3px;
  background: #ffffff;
  border: 0.5px solid #8795a2;
  box-sizing: border-box;
  box-shadow: 0px 1px 18px rgba(129, 129, 129, 0.12),
    0px 3px 5px rgba(129, 129, 129, 0.2), 0px 6px 10px rgba(129, 129, 129, 0.14);
  display: flex;
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  z-index: 2;
`;

export const List = styled.div<TimePickerStylesProps>`
  width: 33.3%;
  border-right: 1px solid #8795a2;
  overflow-y: auto;
  overflow-x: hidden;
  &:last-child {
    border: none;
  }
`;

export const ListItem = styled.div<TimePickerStylesProps>`
  height: 25px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.isActive ? '#0076C0' : '#fff')};
  color: ${(props) => (props.isActive ? '#fff' : '#424242')};
  transition: 0.2s;
  cursor: pointer;
  &:hover {
    background-color: #0076c0;
    color: #fff;
  }
`;

export const Label = styled.div`
  font-size: 11px;
  line-height: 15px;
  color: #333333;
  margin-bottom: 3px;
  span {
    color: #cf4845;
    margin-right: 3px;
  }
`;

export const Info = styled.div`
  width: 100px;
  position: absolute;
  left: calc(100% + 3px);
  top: 22px;
  font-size: 11px;
  line-height: 13px;
  margin-top: 5px;
  color: #333333;
  z-index: 1;
`;

export const ErrrorMessage = styled.div`
  position: absolute;
  bottom: -21px;
  left: 0;
  color: #cf4845;
  font-size: 12px;
  white-space: nowrap;
`;
